var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"zt_img",attrs:{"src":"/asserts/common/zt_unicom.jpg"}})])
}]

export { render, staticRenderFns }